export default {
  colors: {
    black: '#000000',
    blackNeutral: '#161617',
    grayBg: '#F7F9FC',
    gray1: '#F5F5FF',
    gray2: '#EEEEF7',
    gray3: '#DBDBE1',
    gray4: '#959990',
    gray5: '#747478',
    gray6: '#414143',
    infoLight: '#DBE6F3',
    info: '#1C64F2',
    primary: '#562570',
    primaryBlue: '#193280',
    primaryDark: '#461361',
    primaryLight: '#9540C2',
    secondary: '#88C443',
    secondaryAlpha20: 'rgba(140, 196, 75, 0.2)',
    secondaryDark: '#67A61E',
    secondaryLight: '#ACF754',
    supportAlert: '#E7B145',
    supportAlertAlpha20: 'rgba(231, 177, 69, 0.2)',
    supportAlertDark: '#CA9428',
    supportError: '#E54545',
    supportErrorAlpha20: 'rgba(229, 69, 69, 0.2)',
    supportErrorDark: '#B82121',
    supportSuccess: '#36B242',
    supportSuccessDark: '#2E8019',
    white: '#FFFFFF',
  },
  font: {
    family: 'ProximaNova',
    light: 300,
    regular: 400,
    semiBold: 600,
    bold: 700,
    black: 900,
    sizes: {
      h1: '52px',
      h2: '40px',
      h3: '32px',
      h4: '28px',
      h5: '24px',
      h6: '20px',
      p1: '16px',
      p2: '14px',
      p3: '12px',
    },
    lineHeights: {
      h1: '64px',
      h2: '52px',
      h3: '44px',
      h4: '40px',
      h5: '36px',
      h6: '32px',
      p1: '28px',
      p2: '24px',
      p3: '20px',
    },
  },
  spacings: {
    xxsmall: '4px',
    xsmall: '8px',
    small: '12px',
    medium: '16px',
    large: '20px',
    xlarge: '24px',
    xxlarge: '28px',
    xxxlarge: '32px',
  },
  border: {
    radius: {
      xsmall: '4px',
      small: '8px',
      medium: '16px',
      large: '24px',
      xlarge: '32px',
      circle: '100%',
    },
  },
  grid: {
    xldesktop: {
      breakpoint: '1366px',
      container: '1232px',
    },
    desktop: {
      breakpoint: '1280px',
      container: '1140px',
    },
    xltablet: {
      breakpoint: '1240px',
      container: '960px',
    },
    tablet: {
      breakpoint: '768px',
      container: '720px',
    },
    mobile: {
      breakpoint: '600px',
      container: '540px',
    },
  },
  layers: {
    base: 1,
    menu: 2,
    overlay: 3,
    modal: 4,
  },
  shadow: {
    lv1: '0 4px 16px rgba(0, 0, 0, 0.08)',
    lv2: '0 8px 24px rgba(0, 0, 0, 0.08)',
    lv3: '0 16px 32px rgba(0, 0, 0, 0.08)',
    lv4: '0 16px 48px rgba(0, 0, 0, 0.08)',
    btDefault: '0 5px 8px rgba(160, 61, 140, .15)',
    small: '0px 2px 4px rgba(0, 0, 0, 0.08)',
    medium: '0px 8px 16px rgba(0, 0, 0, 0.1)',
  },
};
